import axios from 'axios';
import qs from 'qs';

export async function fetchCoins(items, filters) {
  const response = await axios.get('/data/coins', {
    params: {
      items: items,
      filters: filters
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    }
  });
  return response.data.data.map(coin => {
    return { ...coin, coin: { name: coin.name, ticker: coin.ticker } };
  });
}

export async function fetchSentiment(categories) {
  return axios.post('/data/collective_coins/sentiment', {
    categories: categories
  });
}
export async function savePageVisits(route) {
  return axios.post('/add_page_visits', { path: route.path, name: route.name });
}

export async function fetchTwitterData(categories) {
  return axios.post('/data/collective_coins/twitter', {
    categories: categories
  });
}

export async function fetchUniversalData() {
  return (await axios.get('/data/coin_universe')).data;
}

export async function fetchCategories() {
  return (await axios.get('/data/categories')).data;
}

export async function fetchGasFees() {
  return (await axios.get('/data/gas_fees')).data;
}

export async function GasFeeGraphData() {
  return (await axios.get('/data/gas_fees')).data;
}

export async function loadStaticData() {
  return (await axios.get('/data/static_data')).data;
}
export async function loadUserNotifications() {
  return (await axios.get('/notifications', { params: { offset: 0, limit: 100 } })).data;
}

export async function fetchWatchlists() {
  return (await axios.get('/data/watchlists')).data;
}

export async function fetchIntegrationTeamCoins() {
  const response = await axios.get('/integrations/coins');
  return response.data.data.map(coin => {
    return { ...coin, coin: { name: coin.name, ticker: coin.ticker } };
  });
}

export async function fetchIntegrationCategories() {
  return (await axios.get('/integrations/categories')).data;
}
